module.exports = __webpack_public_path__ + "static/media/haruna.d8449c08.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haruna.jpeg
// module id = 42
// module chunks = 0